<template>
  <van-popup
    class="popup_box"
    v-model:show="showValue"
    round
    :style="{ padding: '64px' }"
    @click-overlay="cancel"
    :transition-appear="true"
  >
    <div @click="cancel" class="popup_close close_center"><span></span></div>
    <div v-if="verifkStep > 1" style="float: left; color: #95a5a5" @click="verifkStep = 1">
      <i class="bi bi-arrow-left-short"></i>
    </div>
    <div class="popup">
      <h1 style="color: #000; font-weight: bold">
        {{ $t('userBar.register').toUpperCase() }}<br /><br />
        <div v-if="verifkStep != 1" style="height: 1.7rem"></div>
      </h1>
      <div style="height: 0.3rem"></div>
      <InputField
        v-if="country == 'BR'"
        v-model="username"
        :placeholder="$t('register.username-tip')"
        style="margin-bottom: 0.2rem"
        :validate="validateUsername"
        :isPhone="true"
        :maxlength="10"
        from="register"
        type="number"
        :focus="usernameFocus"
        :enter="
          () => {
            passwordFocus = true
          }
        "
      />
      <InputField
        v-if="country == 'BR'"
        v-model="password"
        :placeholder="$t('register.password-tip')"
        type="password"
        style="margin-bottom: 0.2rem"
        :validate="validatePassword"
        :focus="passwordFocus"
        :enter="
          () => {
            passwordFocus = false
            onSignup()
          }
        "
      />
      <div v-if="country == 'BR'" class="submit" @click="onSignup">
        {{ $t('register.signup') }}
      </div>
      <LobbyVerify
        v-else
        title=""
        :key="verifyKey"
        :verify="sms"
        :api="onRegister"
        from="register"
        :changeStep="changeStep"
        :verifkStep="verifkStep"
        style="margin-top: -0.3rem"
      />
      <!-- <a class="sign-in" v-html="$t('register.sign-in')" @click="onOpenLogin"></a> -->
      <!-- <div class="desc" v-html="$t('register.desc')" @click="onJumpTC"></div> -->
      <span v-if="verifkStep == 1" style="text-align: center; color: #9ca0ab" @click="onOpenLogin"
        >{{ $t('register.sign-in')
        }}<span style="color: #517ab8; text-decoration-line: underline" @click="onOpenLogin"
          >&nbsp;{{ $t('register.login-now') }}</span
        ></span
      >
      <div style="height: 1.2rem"></div>
      <div
        v-if="verifkStep == 1"
        class="desc"
        @click="onJumpTC"
        style="margin-top: 0.2rem; text-decoration: underline"
      >
        {{ $t('register.next-tc') }}
      </div>
      <!-- <div class="desc" @click="onJumpTC" style="margin-top: 0.2rem">
        <i class="bi bi-check2-square"></i>&nbsp;&nbsp;&nbsp;&nbsp;I declare that I am over 18
      </div>
      <div class="desc" @click="onJumpTC">
        <i class="bi bi-check2-square"></i>&nbsp;&nbsp;&nbsp;&nbsp;I accept Terms and Conditions.
      </div> -->
      <!-- <div class="popup_footer" @click="onChat" style="font-size: 0.28rem">
        {{ $t('register.service') }}
      </div> -->
    </div>
    <!-- <LobbyVerify title="" :key="verifyKey" :verify="sms" :api="onRegister" from="register" /> -->
  </van-popup>
</template>

<script>
import { mapActions, mapState } from 'pinia'
import { useUserStore } from '@/stores/user'
import InputField from '@/components/active/ActiveInputField.vue'
import LobbyVerify from '@/components/active/ActiveLobbyVerify.vue'
import { BUS, POPUP } from '@/event/EventCenter'
import { validatePassword, validateUsername } from '@/common/valiadate.js'
import { showLoadingToast, showSuccessToast } from 'vant'
import { REPORT_EVENT, reportGtag } from '@/common/mgtag'
import { useEnvelopeStore } from '@/stores/envelope'
import { PIXEL_EVENT, mfbq } from '@/common/mFbq'
import { AIRBRIDEG_EVENT, airbrideg_report } from '@/common/airbridge'
import { removeLocalStorage } from '@/common/localStorage'
export default {
  name: 'LobbyRegister',
  components: { InputField, LobbyVerify },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    cancel: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      showValue: false,
      username: '',
      password: '',
      verifyKey: 0,
      verifkStep: 1,
      usernameFocus: true,
      passwordFocus: false
    }
  },
  watch: {
    show(newValue) {
      if (this.showValue == newValue) {
        return
      }
      this.showValue = newValue
      if (this.showValue) {
        reportGtag(REPORT_EVENT.REGISTER.R1_COMPLETED, 'exposure')
      }
      this.verifyKey++
    }
  },
  computed: {
    ...mapState(useUserStore, ['country', 'countries']),
    ...mapState(useEnvelopeStore, ['envelopeId', 'inviteUserId'])
  },
  mounted() {
    this.showValue = this.show
  },

  methods: {
    validatePassword,
    validateUsername,
    ...mapActions(useUserStore, {
      register: 'register',
      sms: 'sms'
    }),
    check() {
      if (this.validateUsername(this.username).length > 0) {
        return false
      }
      return this.validatePassword(this.password).length <= 0
    },
    onSignup() {
      this.$bus.$emit(BUS.CHECK_INPUT_VALUE, 'register')
      if (!this.check()) {
        return
      }
      showLoadingToast({
        message: '',
        forbidClick: true,
        duration: 0
      })
      this.register(
        this.country,
        this.password,
        this.username,
        '',
        parseInt(this.envelopeId),
        parseInt(this.inviteUserId)
      ).then((response) => {
        if (response) {
          mfbq(PIXEL_EVENT.COMPLETE_REGISTRATION)
          showSuccessToast({
            message: this.$t('register.success'),
            wordBreak: 'break-word',
            onClose: () => {
              this.$bus.$emit(BUS.SHOW_POPUP, { from: 'register', to: POPUP.REGISTER, show: false })
            },
            duration: 3000
          })
        }
      })
    },
    onRegister(country, password, username, verificationCode) {
      showLoadingToast({
        message: '',
        forbidClick: true,
        duration: 0
      })
      reportGtag(REPORT_EVENT.REGISTER.R2_REGISTER, 'click')
      this.register(
        country,
        username,
        password,
        verificationCode,
        parseInt(this.envelopeId),
        parseInt(this.inviteUserId)
      )
        .then((response) => {
          if (response) {
            mfbq(PIXEL_EVENT.COMPLETE_REGISTRATION)
            airbrideg_report(AIRBRIDEG_EVENT.SIGNUP)
            removeLocalStorage('invite')
            showSuccessToast({
              message: this.$t('register.success'),
              wordBreak: 'break-word',
              onClose: () => {
                this.$bus.$emit(BUS.SHOW_POPUP, {
                  from: 'register',
                  to: POPUP.REGISTER,
                  show: false
                })
              },
              duration: 3000
            })
          } else {
            this.verifyKey++
          }
        })
        .catch(() => {
          this.verifyKey++
        })
    },
    onOpenLogin() {
      this.$bus.$emit(BUS.SHOW_POPUP, { from: 'register', to: POPUP.LOGIN, show: true })
    },
    onChat() {
      this.$bus.$emit(BUS.SHOW_CHAT)
      reportGtag(REPORT_EVENT.REGISTER.CUSTOMER_SERVICE, 'click')
    },
    onFocusUserName() {
      reportGtag(REPORT_EVENT.REGISTER.R1_ACCOUNT_NUMBER, 'click')
    },
    onFocusPassWord() {
      reportGtag(REPORT_EVENT.REGISTER.R3_PASSWORD, 'click')
    },
    onJumpTC() {
      this.$router.replace('/tc')
      reportGtag(REPORT_EVENT.REGISTER.TC, 'click')
    },
    changeStep(step) {
      this.verifkStep = step
      console.log('asdfasdf', this.verifkStep)
    }
  }
}
</script>

<style lang="scss" scoped>
.popup_box {
  width: 6.5rem;
  height: auto;
  margin: 0 auto;
  padding: 0 !important;
  overflow: visible !important;
  border: solid 0.04rem transparent;
  border-radius: 0.16rem;
  background-color: #f1f1f1;
  // background-image: linear-gradient(#000, #000),
  //   linear-gradient(130deg, #dfc572 0%, #916c38 50%, #825c2d 50.1%, #aa884a 100%);
  // background-origin: border-box;
  // background-clip: content-box, border-box;
  text-align: center;

  .popup {
    width: 90%;
    height: auto;
    border-radius: 12px;
    display: block;
    padding: 5% 5% 0 5%;
    margin: 0 auto;
    font-size: 0.24rem;

    .banner {
      width: 5.4rem;
      height: 1.29rem;
      margin-top: 0rem;
      border-radius: 0.2rem;
      margin-bottom: 0.39rem;
    }

    h1 {
      font-size: 0.38rem;
      line-height: 0.3rem;
      margin: 0.1rem 0;
      font-weight: normal;
    }

    h2 {
      font-size: 0.24rem;
      line-height: 0.3rem;
      margin: 0.1rem 0;
      font-weight: normal;
    }

    p {
      line-height: 0.32rem;
      margin: 0;
      color: #fff;
    }

    .submit {
      width: 100%;
      height: var(--input-height);
      border-radius: 0.44rem;
      background: #336aea;
      line-height: var(--input-height);
      font-weight: 400;
      font-size: 0.3rem;
      color: #ffffff;
      text-align: center;

      &:active {
        background: #98aa4a;
      }
    }

    .sign-up {
      display: flex;
      justify-content: flex-end;
      margin: 0.36rem 0;
      width: 100%;
      font-weight: 400;
      font-size: 0.23rem;
      color: #9ca0ab;
      text-align: right;

      span {
        color: #517ab8 !important;
      }
    }

    .popup_footer {
      text-align: center;
      margin: 0px;
      padding: 0.3rem 0 0.3rem;
      height: auto;
      width: 100%;
      color: #517ab8;
      font-size: 0.38rem;

      overflow: hidden;
      text-decoration: underline;
    }

    .sign-in {
      display: flex;
      justify-content: flex-end;
      width: 100%;
      margin-top: 0.34rem;
      margin-bottom: 0.2rem;
      font-weight: 400;
      font-size: 0.24rem;
      color: #9ca0ab;
      // text-decoration-line: underline;
      cursor: pointer;
      text-align: right;
    }

    .desc {
      // margin-top: 0.59rem;
      // margin-bottom: 0.15rem;
      font-weight: 400;
      font-size: 0.23rem;
      // color: #95a5a5;
      color: #9ca0ab;
      text-align: center;
      // margin-left: 1rem;
    }
  }

  .close_center {
    display: flex !important;
    margin-top: -0.5rem !important;
    justify-content: center;
    align-items: flex-start;
  }

  .popup_close {
    height: 0.8rem;
    width: 0.8rem;
    top: 0.5rem;
    text-align: center;
    position: absolute;
    display: block;
    z-index: 2;
    right: 0rem;

    span {
      display: inline-block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: #95a5a5;
      background-image: linear-gradient(130deg, #95a5a5 0%, #95a5a5 100%);
      transform: rotate(45deg);
      margin-top: 0.355rem;
    }

    span::after {
      content: '';
      display: block;
      width: 0.6rem;
      height: 0.08rem;
      background-color: 95a5a5;
      background-image: linear-gradient(130deg, #95a5a5 0%, #95a5a5 100%);
      transform: rotate(-90deg);
    }
  }
}
</style>
